import { useState } from "react";
import type { BoardSnapshot } from "../types";

// Month calendar placing items on their Deadline (date column).
export function CalendarView({ snap }: { snap: BoardSnapshot }) {
  const dateCol = snap.columns.find((c) => c.type === "date") ?? snap.columns.find((c) => c.title === "Deadline");
  const [cursor, setCursor] = useState(() => new Date());

  const year = cursor.getFullYear(), month = cursor.getMonth();
  const first = new Date(year, month, 1);
  const startDow = (first.getDay() + 6) % 7; // Monday-first
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const events: Record<string, string[]> = {};
  if (dateCol) {
    for (const it of snap.items) {
      const v = it.cells[dateCol.id];
      if (v && typeof v === "object" && "date" in v && v.date) {
        const dt = new Date(v.date);
        if (dt.getFullYear() === year && dt.getMonth() === month)
          (events[dt.getDate()] ??= []).push(it.name);
      }
    }
  }

  const cells: Array<number | null> = [];
  for (let i = 0; i < startDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const dows = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

  return (
    <div className="board-scroll">
      <div className="toolbar" style={{ paddingLeft: 0 }}>
        <button className="btn btn-ghost btn-sm" onClick={() => setCursor(new Date(year, month - 1, 1))}>‹</button>
        <strong>{cursor.toLocaleDateString("de-DE", { month: "long", year: "numeric" })}</strong>
        <button className="btn btn-ghost btn-sm" onClick={() => setCursor(new Date(year, month + 1, 1))}>›</button>
      </div>
      <div className="cal-grid">
        {dows.map((d) => <div key={d} className="cal-day" style={{ minHeight: 0, padding: 4 }}>{d}</div>)}
        {cells.map((d, i) => (
          <div key={i} className="cal-cell">
            {d && <div className="cal-day">{d}</div>}
            {d && (events[d] ?? []).map((nm, j) => <div key={j} className="cal-ev" title={nm}>{nm}</div>)}
          </div>
        ))}
      </div>
    </div>
  );
}
